/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Strength_GapInputs */

const en_story_bank_strength_gap = /** @type {(inputs: Story_Bank_Strength_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap`)
};

const de_story_bank_strength_gap = /** @type {(inputs: Story_Bank_Strength_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap`)
};

const fr_story_bank_strength_gap = /** @type {(inputs: Story_Bank_Strength_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap`)
};

const es_story_bank_strength_gap = /** @type {(inputs: Story_Bank_Strength_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap`)
};

const it_story_bank_strength_gap = /** @type {(inputs: Story_Bank_Strength_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap`)
};

const nl_story_bank_strength_gap = /** @type {(inputs: Story_Bank_Strength_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap`)
};

const pl_story_bank_strength_gap = /** @type {(inputs: Story_Bank_Strength_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap`)
};

const fi_story_bank_strength_gap = /** @type {(inputs: Story_Bank_Strength_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap`)
};

const da_story_bank_strength_gap = /** @type {(inputs: Story_Bank_Strength_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap`)
};

const sv_story_bank_strength_gap = /** @type {(inputs: Story_Bank_Strength_GapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gap`)
};

/**
* | output |
* | --- |
* | "Gap" |
*
* @param {Story_Bank_Strength_GapInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_strength_gap = /** @type {((inputs?: Story_Bank_Strength_GapInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Strength_GapInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_strength_gap(inputs)
	if (locale === "fr") return fr_story_bank_strength_gap(inputs)
	if (locale === "es") return es_story_bank_strength_gap(inputs)
	if (locale === "it") return it_story_bank_strength_gap(inputs)
	if (locale === "nl") return nl_story_bank_strength_gap(inputs)
	if (locale === "pl") return pl_story_bank_strength_gap(inputs)
	if (locale === "fi") return fi_story_bank_strength_gap(inputs)
	if (locale === "da") return da_story_bank_strength_gap(inputs)
	if (locale === "sv") return sv_story_bank_strength_gap(inputs)
	return en_story_bank_strength_gap(inputs)
});